import { HomeHeader } from "./home/HomeHeader";
import { HomeHero } from "./home/HomeHero";
import { Footer } from "./Footer";

export function HomePage() {
  return (
    <div className="min-h-screen flex flex-col">
      <HomeHeader />
      <div className="bg-accent text-accent-foreground text-center py-3">
        <p className="text-sm sm:text-base font-bold tracking-[0.15em] uppercase">
          Coaching, Job Skills, &amp; Independence After Treatment
        </p>
      </div>
      <main className="flex-1 flex flex-col">
        <HomeHero />
      </main>
      <Footer className="bg-[#1A2744] text-white py-12" />
    </div>
  );
}
